import { useContext } from 'react';

import LargeSizeContext from 'contexts/largeSizeContext';

type ReturnType = {
  LSModeEnabled: boolean;
};

export default function useLargeSizeMode(): ReturnType {
  const { isLargeMode } = useContext(LargeSizeContext);

  return {
    LSModeEnabled: isLargeMode,
  };
}
